import { render } from "./cell-rating.vue?vue&type=template&id=595bf3df"
import script from "./cell-rating.vue?vue&type=script&lang=js"
export * from "./cell-rating.vue?vue&type=script&lang=js"

import "./cell-rating.vue?vue&type=style&index=0&id=595bf3df&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__